/** Shared capture-button colors for web's static stand-in and mobile's real buttons, so they can't silently drift apart. */
export const compositionCaptureButtonColors = {
  background: "#F8F9FA",
  border: "#E9ECEF",
  text: "#666666",
} as const;

/** Matches web's Tailwind spacing-3 (12px); each child carries its own spacing, not one container inset. */
export const COMPOSITION_CARD_PADDING = 12;
